module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHgAAAB4BAMAAADLSivhAAAAJ1BMVEUAAADd3d3d3d3e3t7d3d3e3t7g4ODg4OD4+Pjd3d309PTg4ODk5OTBEN6YAAAACHRSTlMA8+PIvWVJGU8Qe9MAAACySURBVFjD7dm9DcIwFMTxV4AYgCoLIFFS0tHS0dIyAWOgdOGjOLFAJFgARmAqSgdbYPGcJtL/Kj+ffhOcxdnNwjtpcpkf/25CpO8NeMB4vJAr043ZZC1nznsbyZ2Vbf34Yku9Dt1IneNXc9fJKrU+XKux8JXH8d0vflxjFJosvj0TlTYpzgcMBoPBYDAYDAaDwWAwGAwGg8HgT1yp9dlaTTII5BMGgaIpomgEKZpfioafN31D+pqncwDsAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/base/order_details_calendar.png
// module id = yyaa
// module chunks = 0